import { render } from "./SideNavComponentAdmin.vue?vue&type=template&id=557b2454"
import script from "./SideNavComponentAdmin.vue?vue&type=script&lang=js"
export * from "./SideNavComponentAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__